/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/28 10:23
 * @FileName: about.js
 * @LastEditor: 2022/9/28 10:23
 * @Name: aboutUs
 */


const aboutUs = {
  routes: [
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/about-us/about-us.vue')
    },
    {
      path: '/article',
      name: 'article',
      meta: {
        title: ''
      },
      component: () => import('@/project/views/about-us/article/article.vue')
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/about-us/disclaimer/disclaimer.vue')
    },
    {
      //companyProfile
      path: '/companyProfile',
      name: 'companyProfile',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/about-us/company-profile/company-profile.vue')
    },
    {
      // antiMoneyLaunderingPolicy
      path: '/antiMoneyLaunderingPolicy',
      name: 'antiMoneyLaunderingPolicy',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/about-us/anti-money-laundering-policy/anti-money-laundering-policy.vue')
    },
    {
      // enterpriseHonor
      path: '/enterpriseHonor',
      name: 'enterpriseHonor',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/about-us/enterprise-honor/enterprise-honor.vue')
    }
  ]
}
export default aboutUs




// WEBPACK FOOTER //
// ./src/project/router/aboutUs.js